var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_vm._v("\n  "+_vm._s(_vm._f("toDistanceFormat")(_vm.params.value))+" nm\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }